import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: "I used to spend my entire Sunday building practice plans and skill progressions from scratch. With Gymnastics Coach Pro I open the Practice Builder, pick a framework, and I'm ready in minutes. I've reclaimed at least 6 hours a week — and my practices are more structured than they've ever been.",
  author: 'Rachel Simmons',
  role: 'Head Coach, Competitive Team',
  location: 'Columbus, OH'
}, {
  text: 'As a first-year coach I was terrified of running my own sessions. The Skill Progression Library gave me exactly the step-by-step path I needed to safely teach new skills. My gymnasts trust me, and I finally feel like I know what to teach next every single practice.',
  author: 'Ashley Turner',
  role: 'Recreational Gymnastics Coach',
  location: 'Austin, TX'
}, {
  text: 'The Season Planning System changed how I run my whole gym. I map out training cycles, competition prep, and athlete development in one place instead of guessing week to week. My level 4–7 girls are progressing faster than any group I’ve had.',
  author: 'Michael Reyes',
  role: 'Program Director & Coach',
  location: 'Denver, CO'
}, {
  text: 'The bonuses alone are worth ten times the price. The Station Builder and the Games & Engagement Vault keep my rec classes moving and fun, and parents constantly comment on how organized every practice looks. No more scrambling before class.',
  author: 'Danielle Foster',
  role: 'Preschool & Rec Gymnastics Coach',
  location: 'Portland, OR'
}, {
  text: "I coach part-time around a full-time job, so planning time is everything. The ready-to-use practice plans and Coaching Toolkit let me walk onto the floor fully prepared with almost no prep. Retention in my program is the highest it's been in 8 years.",
  author: 'Sofia Herrera',
  role: 'Club Owner & Head Coach',
  location: 'Miami, FL'
}];
export function Testimonials() {
  return <section className="py-8 px-4 bg-brand-cloud border-y border-brand-line" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <div className="text-center mb-6" data-id="element-187">
          <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-brand-ink mb-1 uppercase" data-id="element-188">
            What Your Fellow Coaches Are Saying
          </h2>
          <p className="text-base font-bold text-brand-navy uppercase tracking-wide" data-id="element-189">
            Testimonials from gymnastics coaches
          </p>
        </div>

        <div className="space-y-3" data-id="element-190">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-line p-4 rounded-xl shadow-sm" data-id="element-191">
              <div className="flex gap-1 mb-2" data-id="element-192">
                {[...Array(5)].map((_, s) => <StarIcon key={s} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-193" />)}
              </div>
              <p className="text-brand-slate font-medium mb-3 leading-snug italic text-sm sm:text-base" data-id="element-194">
                "{t.text}"
              </p>
              <div className="border-t border-brand-line pt-3 flex items-center gap-3" data-id="element-195">
                <div className="w-10 h-10 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue font-display font-extrabold text-lg" data-id="element-196">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-197">
                  <p className="font-bold text-brand-ink text-sm" data-id="element-198">{t.author}</p>
                  <p className="text-[11px] sm:text-xs text-brand-slate font-bold uppercase tracking-wide" data-id="element-199">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}